import createReactComponent from '../createReactComponent';
export default createReactComponent('circle-letter-y', 'IconCircleLetterY', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M10 8l2 5l2 -5', key: 'svg-1' }],
  ['path', { d: 'M12 16v-3', key: 'svg-2' }],
]);
